<template>
    <div class="row ml-0 mr-0">
        <div class="col-12 col-md-12 p-0 place-preview">
            <span class="float-left">Điểm đón:</span>
            <b class="rv-tran-from">{{pickupLocation|| 'Vui lòng chọn điểm đón'}}</b>
        </div>
        <div class="col-md-12 col-12 p-0 place-preview">
            <span class="float-left">Điểm trả:</span>
            <b class="rv-tran-to">{{getOffLocation || 'Vui lòng chọn điểm trả'}}</b>
        </div>
    </div>
</template>

<script>
    import {MixinHelper} from "../../../shared/services";

    export default {
        name: "PlacePreview",
        mixins:[MixinHelper],
        props: {
            places: {
                type: Object
            },
            price: {
              type: Number,
              default: 0,
            }
        },
        data() {
            return {
                pickupLocation: '',
                getOffLocation: ''
            }
        },
        watch: {
            'places.pickupLocations': {
                handler: function (val) {
                    this.pickupLocation = this.getProp(val, '$model[0].address', '');
                },
                deep: true
            },
            'places.getOffLocations': {
                handler: function (val) {
                    this.getOffLocation = this.getProp(val, '$model[0].address', '');
                },
                deep: true
            }
        },
    }
</script>

<style scoped>
    .place-preview {
        min-height: 25px;
    }
    .rv-tran-from, .rv-tran-to {
        font-size: 13px;
        text-align: right;
        float: right;
    }

    .rv-tran-from {
        width: 80%;
        word-break: break-word;
    }

    .rv-tran-to {
        width: 76%;
        word-break: break-all;
    }
</style>
